<script setup lang="js">

import { useAuthStore } from "@/stores/auth";
import { useBusinessStore } from "@/stores/business";
import { ChatBubbleLeftEllipsisIcon } from "@heroicons/vue/16/solid";

const props = defineProps({
      id: {
        type: Number,
        required: true
      },
      count: {
        default: 0,
        type: Number,
        required: true
      },
      size: {
        default: 'h-4 w-4',
        type: String
      },
      from: {
        default: 'single',
        type: String,
      },
      fontSize: {
        default: 'text-xs',
        type: String
      },
      userHasReviewed: {
        default: false,
        type: Boolean,
        required: true
      },
    }),
    store = useBusinessStore(),
    toggleLikeStatus = (id) => {
      if (useAuthStore().guest) {
        return alert('You need to be logged in to perform this action');
      }
      store.toggleBusinessLike(id, props.from);
    };
</script>

<template>
  <small
    class="mr-2 flex justify-between items-center"
    @click="toggleLikeStatus(props.id)"
  >
    <ChatBubbleLeftEllipsisIcon
      :class="[
        props.size, 'text-center cursor-pointer mr-1',
        props.userHasReviewed ? 'text-green-500' : 'text-gray-400'
      ]"
      :title="props.userHasReviewed ? 'Unlike':'Like'"
      :aria-hidden="props.userHasReviewed"
    />
    <span :class="`${fontSize} text-gray-400 font-semibold`">{{ props.count ?? null }}</span>
  </small>
</template>

<style scoped>

</style>
